import axios from 'axios';

export default () => {
  return axios.create({
    // baseURL: `http://localhost:3000/api/`,

    baseURL: `https://mpkoodit.fi/test_project/api/`,
  });
};
